import { hasRisk } from '@utils/helper-utils';

import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const insuredsValidationSchema = (lineCode: string) => {
  return Yup.object().shape({
    insuredPerson: Yup.array().of(
      Yup.object().shape({
        id: requiredText(),
        address: requiredText(),
        limitOfCover: Yup.string().when([], {
          is: () => hasRisk(lineCode),
          then: () => requiredText(),
          otherwise: (schema) => schema.notRequired().nullable()
        })
      })
    )
  });
};
